import React, { useState, useEffect } from 'react'
import Congratulations from './Congratulations/Congratulations'
import { useSelector } from 'react-redux'
import { BookMode } from 'store/services/Book'
import { asyncUpdateGlobalScore, selectCurrentUser } from 'store/services/User'
import useThunkDispatch from 'hooks/useThunkDispatch'

const OnboardingFinished: React.FC = () => {
  const [starsFlying, setStarsFlying] = useState(false)
  const profile = useSelector(selectCurrentUser)?.profile
  const dispatch = useThunkDispatch()

  const onDidMount = () => {
    if (profile!.globalScore! < 1000) {
      setTimeout(() => {
        dispatch(asyncUpdateGlobalScore(1000))
      }, 2000)
      setTimeout(() => {
        setStarsFlying(true)
      }, 2250)
    }
  }

  useEffect(onDidMount, [])

  return (
    <Congratulations
      name={profile!.firstName}
      bookMode={BookMode.READ}
      bookTitle="Onboarding Book"
      bookTotalPoints={1000}
      globalScore={profile!.globalScore!}
      starsFlying={starsFlying}
    />
  )
}

export default OnboardingFinished
